import { render, staticRenderFns } from "./MeasurementsTable.vue?vue&type=template&id=f625b588&"
import script from "./MeasurementsTable.vue?vue&type=script&lang=js&"
export * from "./MeasurementsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports